import Vacations from '@/views/vacations/Vacations.vue';
import Vacation from '@/views/vacations/Vacation.vue';
import RemainingPaidLeave from '@/views/vacations/RemainingPaidLeave.vue';
import { TRDOSIE_COMPANIES } from '@/common/companies';

export default [
  {
    path: '/vacations',
    name: 'vacations',
    component: Vacations,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vacations/new',
    name: 'newVacation',
    component: Vacation,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vacations/remaining-paid-leave',
    name: 'remainingPaidLeave',
    component: RemainingPaidLeave,
    meta: {
      requiresAuth: true,
      rolesAllowed: ['admin', 'hr', 'supervisor'],
      companiesAllowed: TRDOSIE_COMPANIES,
    },
  },
  {
    path: '/vacations/:id',
    name: 'editVacation',
    component: Vacation,
    meta: {
      requiresAuth: true
    }
  }
];
